import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      margin: '2rem 0.8rem',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      '& h1': {
        fontWeight: 600,
      },

      '& .MuiGrid-container': {
        marginBottom: '1rem',
        overflow: 'auto',
        minHeight: 0,

        '& > .MuiGrid-item:nth-child(1)': {
          marginBottom: '1rem',
        },

        '& > .MuiGrid-item:nth-child(2) > h6': {
          marginBottom: '1.6rem',
        },
      },
    },

    inputsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.6rem',

      '& .MuiTextField-root': {
        margin: 0,
        width: '100%',
      },
    },

    menuList: {
      '& > li': {
        fontSize: '1.4rem',
        color: palette.secondary.main,
        padding: '1.2rem 1.6rem',
        lineHeight: '2rem',
      },
      '& .MuiListSubheader-root': {
        fontWeight: 600,
      },
    },

    buttonsContainer: {
      marginTop: 'auto',

      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',

      '& > button, & > a': {
        margin: 0,
        width: 'fit-content',
      },
    },
  }),
)
